/* eslint-disable import/prefer-default-export */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { locales, setNotification } from 'utils';
import { push } from 'react-router-redux';
import {
    loadPaymentTypeRes,
    loadPaymentTypeErr,
    loadEditablePaymentTypeRes,
    loadEditablePaymentTypeErr,
    addPaymentTypeRes,
    addPaymentTypeErr,
    editPaymentTypeRes,
    editPaymentTypeErr,
} from '../actions/paymentTypeActions';

import {
    getPaymentTypeApi,
    addPaymentTypeApi,
    editPaymentTypeApi,
    updateTranslatePaymentTypeApi,
} from '../api/paymentTypeApi';

import * as PaymentTypeTypes from '../types/paymentTypeTypes';

const getLayout = state => state.layout;
const getPaymentType = state => state.paymentType;

// L O A D   P A Y M E N T   T Y P E
function* loadPaymentTypeSaga() {
    try {
        const paymentType = yield select(getPaymentType);
        const { offset, limit } = paymentType;
        const params = {
            offset,
            limit,
        };

        const result = yield getPaymentTypeApi(params);

        if (result.status === 200) {
            yield put(loadPaymentTypeRes(result.data));
        } else {
            yield put(loadPaymentTypeErr());
        }
    } catch (e) {
        yield put(loadPaymentTypeErr());
        console.log(e);
    }
}

export function* loadPaymentTypeWatcher() {
    yield takeLatest(PaymentTypeTypes.LOAD_PAYMENT_TYPE, loadPaymentTypeSaga);
}
// L O A D   P A Y M E N T   T Y P E

// L O A D   E D I T A B L E   P A Y M E N T   T Y P E
function* loadEditablePaymentTypeSaga(action) {
    try {
        const paymentType = yield select(getPaymentType);
        const { offset, limit } = paymentType;

        const params = {
            offset,
            limit,
        };

        params.filter = JSON.stringify({ _id: action.id });

        const result = yield getPaymentTypeApi(params);

        if (result.status === 200) {
            yield put(loadEditablePaymentTypeRes(result.data));
        } else {
            yield put(loadEditablePaymentTypeErr());
        }
    } catch (e) {
        yield put(loadEditablePaymentTypeErr());
        console.log(e);
    }
}

export function* loadEditablePaymentTypeWatcher() {
    yield takeLatest(PaymentTypeTypes.LOAD_EDITABLE_PAYMENT_TYPE, loadEditablePaymentTypeSaga);
}
// L O A D   E D I T A B L E   P A Y M E N T   T Y P E

// U P D A T E   P A Y M E N T   T Y P E   T R A N S L A T E
function* updatePaymentTypeTranslate(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const data = {
            payment_type_id: action.data[0].payment_type_id,
            reseller_id: action.data[0].reseller_id,
        };

        const params = { bulk: [] };
        [...locales, 'de'].forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === 'EDIT_PAYMENT_TYPE')) {
                params.bulk.push({
                    ...data,
                    ...action.data[1][lc],
                });
            }
        });

        const result = yield updateTranslatePaymentTypeApi(params);

        if (result.status !== 202) {
            setNotification('error', locale, 'global.error', 'paymentType.notification.translateError');
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'paymentType.notification.translateError');
        console.log(e);
    }
}
// U P D A T E   P A Y M E N T   T Y P E   T R A N S L A T E

// E D I T   P A Y M E N T   T Y P E
function* editPaymentTypeSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield editPaymentTypeApi(action.data[0]);

        if (result.status === 202) {
            yield call(updatePaymentTypeTranslate, action);

            setNotification('success', locale, 'global.success', 'paymentType.notification.editPaymentType.success');
            yield put(editPaymentTypeRes());
            yield put(push('/settings/payment-types'));
        } else {
            setNotification('error', locale, 'global.error', 'paymentType.notification.editPaymentType.error');
            yield put(editPaymentTypeErr());
        }
    } catch (e) {
        console.log(e);
        yield put(editPaymentTypeErr());
    }
}
export function* editPaymentTypeWatcher() {
    yield takeLatest(PaymentTypeTypes.EDIT_PAYMENT_TYPE, editPaymentTypeSaga);
}
// E D I T   P A Y M E N T   T Y P E

// A D D   P A Y M E N T   T Y P E
function* addPaymentTypeSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;
        const result = yield addPaymentTypeApi(action.data[0]);

        if (result.status === 202) {
            yield call(updatePaymentTypeTranslate, action);

            setNotification('success', locale, 'global.success', 'paymentType.notification.addPaymentType.success');
            yield put(addPaymentTypeRes());
            yield put(push('/settings/payment-types'));
        } else {
            setNotification('error', locale, 'global.error', 'paymentType.notification.addPaymentType.error');
            yield put(addPaymentTypeErr());
        }
    } catch (e) {
        console.log(e);
        yield put(addPaymentTypeErr());
    }
}
export function* addPaymentTypeWatcher() {
    yield takeLatest(PaymentTypeTypes.ADD_PAYMENT_TYPE, addPaymentTypeSaga);
}
// A D D   P A Y M E N T   T Y P E
